import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "./Nav";
import { LegalInfo } from "./LegalInfo";
import { FooterLinks } from "./FooterLinks";
import { useLang } from "../i18n";

export function PublicPage({ title, children }) {
  const { t } = useLang();
  useEffect(() => { document.title = `${title} — RISE your LIFE`; return () => { document.title = "RISE your LIFE"; }; }, [title]);
  return (
    <div className="App min-h-screen">
      <Nav />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="flex items-center gap-2 text-[#6E6B65] mb-6 hover:text-[#3F6E85]" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> {t("legal_back")}
        </Link>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#2B4A59] mb-10" data-testid="page-title">{title}</h1>
        <div className="space-y-8 text-[#3a3a3a] leading-relaxed">{children}</div>
        <FooterLinks className="mt-12 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[14px] text-[#6E6B65]" />
        <LegalInfo className="mt-6 border-t border-stone-200" />
      </div>
    </div>
  );
}

export const SubTitle = ({ children }) => <h2 className="font-serif text-2xl tracking-tight text-[#3F6E85] mb-2">{children}</h2>;
